import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductUnblockService {

  constructor(protected http: HttpClient) { }

  unblockProduct(apikey: string, hash: string): Observable<any> {
    console.log(`Producto ${hash} desbloqueado`);
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
      headers = headers.append('accept', 'application/json'); 
      headers = headers.append('xApiKeyPublic', apikey);
    return this.http.post<any>(environment.urlApi + '/producto/' + hash + '/desbloqueo-temporal', '' ,{headers});    
  }
}
